import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { CHART_COLORS } from '@/components/reports/ProjectsStageChart';
import type { WorkflowStage } from '@/components/forms/WorkflowStageSelect';

const NON_PROPOSAL_STAGES: { value: WorkflowStage; label: string }[] = [
  { value: 'project_setup', label: 'Project Setup' },
  { value: 'design_development', label: 'Design Development' },
  { value: 'permit_preparation', label: 'Permit Preparation' },
  { value: 'in_permit_review', label: 'In Permit Review' },
  { value: 'construction_administration', label: 'Construction Administration' },
  { value: 'on_hold', label: 'On Hold' },
  { value: 'complete', label: 'Complete' },
];

// All 10 stages in order — index determines color assignment
const ALL_STAGES: WorkflowStage[] = [
  'proposal_draft',
  'proposal_sent',
  'proposal_declined',
  'project_setup',
  'design_development',
  'permit_preparation',
  'in_permit_review',
  'construction_administration',
  'on_hold',
  'complete',
];

function getStageColor(stage: WorkflowStage): string {
  const index = ALL_STAGES.indexOf(stage);
  return CHART_COLORS[index % CHART_COLORS.length];
}

interface InlineStageSelectProps {
  projectId: string;
  currentStage: WorkflowStage | null;
  onUpdate: (newStage: WorkflowStage) => void;
}

export function InlineStageSelect({ currentStage, onUpdate }: InlineStageSelectProps) {
  const color = currentStage ? getStageColor(currentStage) : '#94a3b8';

  const handleValueChange = (value: string) => {
    onUpdate(value as WorkflowStage);
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Select value={currentStage ?? undefined} onValueChange={handleValueChange}>
        <SelectTrigger className="h-7 w-auto min-w-[140px] border-0 bg-transparent px-2 py-0 text-xs font-medium shadow-none focus:ring-1 focus:ring-offset-0 hover:bg-muted/50">
          <div className="flex items-center gap-1.5">
            <span
              className="h-2 w-2 rounded-full shrink-0"
              style={{ backgroundColor: color }}
            />
            <SelectValue />
          </div>
        </SelectTrigger>
        <SelectContent>
          {NON_PROPOSAL_STAGES.map((stage) => (
            <SelectItem key={stage.value} value={stage.value}>
              <div className="flex items-center gap-2">
                <span
                  className="h-2 w-2 rounded-full shrink-0"
                  style={{ backgroundColor: getStageColor(stage.value) }}
                />
                {stage.label}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
